import { useCallback } from 'react';
import { useRegisterContext } from '../reducer/useRegister';
import { requestRegistrationCode } from '../../rest-api/request';
import { parseAuthError } from '../../rest-api/utils';

export const useRequestRegistrationCode = () => {
  const [state, dispatch] = useRegisterContext();
  const {
    data: { phoneNumber },
    loading,
  } = state;
  return useCallback(
    async (zipCode: string) => {
      if (loading) {
        return;
      }
      dispatch('LOADING');
      try {
        const response = await requestRegistrationCode(phoneNumber, zipCode);
        dispatch({
          type: 'CREATE_ACCOUNT',
          phoneNumber,
          zipCode,
          sfContactId: response.sf_contact_id,
          agreementTime: new Date(),
        });
      } catch (error) {
        dispatch({
          type: 'REQUESTING_REGISTRATION_CODE',
          phoneNumber,
          error: getErrorReason(error),
        });
      }
    },
    [phoneNumber, loading, dispatch],
  );
};

const getErrorReason = (error: unknown) => {
  const errorResponse = parseAuthError(error);
  const errorCode = errorResponse?.error_code;
  if (!errorCode) {
    return 'generic-error';
  }
  switch (errorCode) {
    case 'CONTACT_NOT_MATCH': {
      const details = errorResponse?.error_details;
      if (details === 'CLIENT_PROFILE_EXISTED') {
        return 'client-existed';
      } else {
        return 'not-match';
      }
    }
    case 'DUPLICATED_USER':
      return 'duplicated';
    case 'ALREADY_SINGED_UP_USING_ANOTHER_PHONE_NUMBER':
      return 'already-signed-up';
    default:
      return 'generic-error';
  }
};
